import React, { useEffect, useState, useCallback } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import FaqService from "../../../services/KangarooServices/FaqService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import DeleteModal from "../../../Components/Common/DeleteModal";
import GroupForm from "../component/GroupForm";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const FAQGroup = () => {
  const [customerList, setCustomerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState();
  console.log("🚀 ~ FAQGroup ~ selectedCustomer:", selectedCustomer)
  const navigate = useNavigate();
  const [data, setdata] = useState([]);

  const [deleteModal, setDeleteModal] = useState(false);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const toggleModal = () => {
    setAddModal(!addModal);
  };
  useEffect(() => {
    const fetchdata = async () => {
      try {
        const data = await FaqService.getList();
        setdata(data);
        console.log("Fetched user:", data);
      } catch (error) {
        console.error("Error getting user:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchdata();
  }, []);
  console.log("data");

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },
    // {
    //   name: "Name",
    //   selector: (row) => `${row.firstName} ${row.lastName}`,
    //   cell: (row) => (
    //     <Link to={`/customer/${row?.id}`}>
    //       {row.firstName} {row.lastName}
    //     </Link>
    //   ),
    //   sortable: true,
    // },
    {
      name: "Name",
      selector: (row) => row.name,

      sortable: true,
    },
    {
      name: "Order",
      selector: (row) => row.order,

      sortable: true,
    },
    // {
    //   name: "Email",
    //   selector: (row) => row.email,
    //   sortable: true,
    // },
    // {
    //   name: "Phone No",
    //   selector: (row) => row.phoneNo,
    //   sortable: true,
    // },
    // {
    //   name: "Customer Type",
    //   selector: (row) => row.customerTypeName,
    //   sortable: true,
    // },
    // {
    //   name: "Discount (%)",
    //   selector: (row) => row.customerTypeDiscount,
    //   sortable: true,
    //   right: true,
    // },

    {
      name: "Action",
      selector: (row) => (
        <div>
          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            onClick={() => {
              setAddModal(true);
              setSelectedCustomer(row);
            }}
          >
            <i className="ri-edit-line" />
          </Button>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
        </div>
      ),
      center: true,
    },
  ];

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const response = await FaqService.getList();

      setCustomerList(response);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ error:", error);
    }
  };

  // Fetch customers when debounced filters, current page or page size changes
  useEffect(() => {
    fetchCustomers();
  }, []);
  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = customerList.filter((pkg) => {
    // console.log("🚀 ~ filteredPackages ~ pkg:", pkg);

    // Combine name, surname, email, and phone number into a single search context, handling undefined fields
    const searchContext = `${pkg?.firstName || ""} ${pkg?.lastName || ""} ${
      pkg?.phoneNo || ""
    }`.toLowerCase();

    // Check if the filterText is included in any of the search context
    const matchesFilter = searchContext.includes(filterText.toLowerCase());

    return matchesFilter;
  });
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const handleDeleteClick = (item) => {
    setSelectedCustomer(item);
    toggleDeleteModal();
  };
  const handleDelete = async () => {
    if (selectedCustomer) {
      try {
        await FaqService.delete(selectedCustomer);
        fetchCustomers();
        toast.success("Selected item deleted successfully");
      } catch (error) {
        toast.error("Failed to delete the record");
      } finally {
        toggleDeleteModal();
        setSelectedCustomer(null);
      }
    }
  };
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Customer List" pageTitle="Customer" />
      </div>
      <Row>
        {/* <Col md={8} xs={10} className="mb-2">
          <InputGroup>
            <Input
              placeholder="Search by name and phone number"
              value={filterText}
              onChange={handleFilterChange}
            />
          </InputGroup>
        </Col> */}
        <Col
          md={12}
          xs={12}
          className="d-lg-flex d-none justify-content-end align-items-end mb-2"
        >
          <button
            className="btn btn-success px-1 px-sm-2"
            onClick={() => setAddModal(true)}
          >
            + Add FAQ Group
          </button>
        </Col>
        <Col
          md={4}
          xs={2}
          className="d-flex d-lg-none justify-content-end align-items-end mb-2"
        >
          <button
            className="btn btn-success  "
            onClick={() => setAddModal(true)}
          >
            +
          </button>
        </Col>
      </Row>
      <Card className="d-none d-lg-block">
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData}
          />
        </CardBody>
      </Card>

      {/* <MobileCustomerForm
        modal={addModal}
        toggleModal={() => {
          setAddModal(false);
          setSelectedCustomer(null); // Clear editing state when closing
        }}
        setCustomerList={setCustomerList}
        customerList={customerList}
        selectedCustomer={selectedCustomer}
        fetchCustomers={fetchCustomers}
      /> */}

      <GroupForm
        isOpen={addModal}
        toggle={toggleModal}
        fetchCustomers={fetchCustomers}
        selectedItem={selectedCustomer}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedCustomer} // Pass the selected item
      />
    </div>
  );
};

export default FAQGroup;
